import { ReactNode } from 'react';
import { Transaction } from '@sentry/types';
import { IURLTopology } from '../../../hook/router';
import { IHandleSentryClose, ITransactionObject } from '../../../hook/sentry/types';
import { IRestaurant } from '../../vendor';

export enum PaymentTypeEnum {
    None = 0,
    Checkout = 1,
    PayTM = 2,
    SMBCLink = 3,
    Stripe = 4,
    StripeConnect = 5,
    DGPay = 6,
    Tuna = 7,
    MasterPass = 8,
    PayPay = 9,
    Moyasar = 10,
    CheckoutPlatform = 11,
    Maf = 12,
    Ticket = 13,
    IndiaGooglePayDirect = 14,
    Vostro = 15,
    Tapp = 16,
    MafV2 = 17,
    Mashreq = 18,
    Adyen = 19,
    MoyasarV2 = 20,
    MasterPassDirect = 21,
    NGenius = 22,
    Tyro = 23,
    CCPP = 24,
    MyFatoorah = 25,
    Divit = 26,
    Moneyhash = 27,
}

export const PaymentTypeName: { [key: number]: string } = {
    [PaymentTypeEnum.None]: 'None',
    [PaymentTypeEnum.Checkout]: 'Checkout',
    [PaymentTypeEnum.PayTM]: 'PayTM',
    [PaymentTypeEnum.SMBCLink]: 'SMBCLink',
    [PaymentTypeEnum.Stripe]: 'Stripe',
    [PaymentTypeEnum.StripeConnect]: 'StripeConnect',
    [PaymentTypeEnum.DGPay]: 'DGPay',
    [PaymentTypeEnum.Tuna]: 'Tuna',
    [PaymentTypeEnum.MasterPass]: 'MasterPass',
    [PaymentTypeEnum.PayPay]: 'PayPay',
    [PaymentTypeEnum.Moyasar]: 'Moyasar',
    [PaymentTypeEnum.MoyasarV2]: 'MoyasarV2',
    [PaymentTypeEnum.CheckoutPlatform]: 'CheckoutPlatform',
    [PaymentTypeEnum.Maf]: 'Maf',
    [PaymentTypeEnum.Ticket]: 'Ticket',
    [PaymentTypeEnum.IndiaGooglePayDirect]: 'IndiaGooglePayDirect',
    [PaymentTypeEnum.Vostro]: 'Vostro',
    [PaymentTypeEnum.Tapp]: 'Tapp',
    [PaymentTypeEnum.MafV2]: 'MafV2',
    [PaymentTypeEnum.Mashreq]: 'Mashreq',
    [PaymentTypeEnum.Adyen]: 'Adyen',
    [PaymentTypeEnum.MasterPassDirect]: 'MasterPassDirect',
    [PaymentTypeEnum.NGenius]: 'NGenius',
    [PaymentTypeEnum.Tyro]: 'Tyro',
    [PaymentTypeEnum.CCPP]: 'CCPP',
    [PaymentTypeEnum.MyFatoorah]: 'MyFatoorah',
    [PaymentTypeEnum.Moneyhash]: 'Moneyhash',
    [PaymentTypeEnum.Divit]: 'Divit',
};

export enum PGNameEnum {
    Checkout = 'checkout',
    CheckoutPlatform = 'checkoutplatform',
    PayTM = 'paytm',
    SMBCLink = 'smbclink',
    Stripe = 'stripe',
    StripeConnect = 'stripeConnect',
    DGPay = 'dgpay',
    Tuna = 'tuna',
    PayPay = 'paypay',
    Moyasar = 'moyasar',
    MoyasarV2 = 'moyasarv2',
    Maf = 'maf',
    Ticket = 'ticketpg',
    IndiaGooglePayDirect = 'indiagooglepaydirect',
    MasterPass = 'masterpass',
    Vostro = 'vostro',
    Tapp = 'tapp',
    MafV2 = 'mafv2',
    Mashreq = 'mashreq',
    Adyen = 'adyen',
    MasterPassDirect = 'masterpassdirect',
    NGenius = 'ngenius',
    Tyro = 'tyro',
    CCPP = 'ccpp',
    MyFatoorah = 'myfatoorah',
    Divit = 'divit',
    Moneyhash = 'moneyhash',
}

export const gatewayMap = {
    [PGNameEnum.Checkout]: PaymentTypeEnum.Checkout,
    [PGNameEnum.CheckoutPlatform]: PaymentTypeEnum.CheckoutPlatform,
    [PGNameEnum.PayTM]: PaymentTypeEnum.PayTM,
    [PGNameEnum.SMBCLink]: PaymentTypeEnum.SMBCLink,
    [PGNameEnum.Stripe]: PaymentTypeEnum.Stripe,
    [PGNameEnum.StripeConnect]: PaymentTypeEnum.StripeConnect,
    [PGNameEnum.DGPay]: PaymentTypeEnum.DGPay,
    [PGNameEnum.Tuna]: PaymentTypeEnum.Tuna,
    [PGNameEnum.PayPay]: PaymentTypeEnum.PayPay,
    [PGNameEnum.Moyasar]: PaymentTypeEnum.Moyasar,
    [PGNameEnum.MoyasarV2]: PaymentTypeEnum.MoyasarV2,
    [PGNameEnum.Maf]: PaymentTypeEnum.Maf,
    [PGNameEnum.Ticket]: PaymentTypeEnum.Ticket,
    [PGNameEnum.IndiaGooglePayDirect]: PaymentTypeEnum.IndiaGooglePayDirect,
    [PGNameEnum.MasterPass]: PaymentTypeEnum.MasterPass,
    [PGNameEnum.Vostro]: PaymentTypeEnum.Vostro,
    [PGNameEnum.Tapp]: PaymentTypeEnum.Tapp,
    [PGNameEnum.MafV2]: PaymentTypeEnum.MafV2,
    [PGNameEnum.Mashreq]: PaymentTypeEnum.Mashreq,
    [PGNameEnum.Adyen]: PaymentTypeEnum.Adyen,
    [PGNameEnum.MasterPassDirect]: PaymentTypeEnum.MasterPassDirect,
    [PGNameEnum.NGenius]: PaymentTypeEnum.NGenius,
    [PGNameEnum.Tyro]: PaymentTypeEnum.Tyro,
    [PGNameEnum.CCPP]: PaymentTypeEnum.CCPP,
    [PGNameEnum.MyFatoorah]: PaymentTypeEnum.MyFatoorah,
    [PGNameEnum.Divit]: PaymentTypeEnum.Divit,
    [PGNameEnum.Moneyhash]: PaymentTypeEnum.Moneyhash,
};

export enum PaymentElementEnum {
    None = 'none',
    ApplePay = 'applepay',
    GooglePay = 'googlepay',
    PixPay = 'pix',
    LinkPay = 'linkpay',
    CardPay = 'card',
    MealVoucherPay = 'mealVoucher',
    STCPay = 'stcpay',
    Loyalty = 'loyalty',
    KNET = 'knet',
    QPay = 'qpay',
    TicketPay = 'ticketpay',
    UnionPay = 'unionpay',
    KNetApplePay = 'knetApplepay',
    Fps = 'fps',
    PayNoW = 'paynow',
}

export const elemOrders = [
    PaymentElementEnum.ApplePay,
    PaymentElementEnum.GooglePay,
    PaymentElementEnum.CardPay,
    PaymentElementEnum.MealVoucherPay,
    PaymentElementEnum.PixPay,
    PaymentElementEnum.LinkPay,
    PaymentElementEnum.STCPay,
    PaymentElementEnum.KNET,
    PaymentElementEnum.QPay,
    PaymentElementEnum.UnionPay,
    PaymentElementEnum.KNetApplePay,
    PaymentElementEnum.Fps,
];

export enum PaymentElementStatusEnum {
    SavedCardPay = 'savedCardPay',
    SavedMealVoucherPay = 'savedMealVoucher',
}

export interface IPayHandler {
    amount: number;
    method: string;
    paymentElement: PaymentElementEnum;
    refId: string;
    tip?: string;
    traceId?: string;
    gatewayId?: string;
}

export interface IGatewayPayHandler extends IPayHandler {
    gatewayId: string;
    traceId: string;
    tableName: string;
    is3ds?: boolean;
    meta?: {
        gaEventSuffix?: string;
        [key: string]: any;
    };
}

export interface IElementPayHandler {
    paymentElement: PaymentElementEnum;
    refId: string;
    traceId?: string;
    is3ds?: boolean;
    meta?: {
        gaEventSuffix?: string;
        [key: string]: any;
    };
}

export interface IPayBeforePaymentHandler {
    tip: number;
    paymentElement: PaymentElementEnum;
    method?: string;
    gatewayId: string;
    additionalData?: any;
    checkTipOnly?: boolean;
    meta?: {
        gaEventSuffix?: string;
        [key: string]: any;
    };
    isFromLoyaltyModule?: boolean;
}

export interface IPGRegister {
    pgId: string;
    elem: PaymentElementEnum;
    name?: string;
    icon?: ReactNode;
    placement?: 'top' | 'middle' | 'bottom';
    buttonElement?: ReactNode;
}

export interface IPGSelect {
    pgId: string;
    elem: PaymentElementEnum;
    bySystem?: boolean;
}

export interface IPGDisable {
    pgId: string;
    elem: PaymentElementEnum;
    force?: boolean;
}

export interface IPGFallbackCallbacks {
    onLoad: (success: boolean) => void;
    onIndicator: () => void;
}

export interface IPGStateCallbacks extends IPGSelector {
    onDone: (payload: IElementPayHandler) => void;
    onFail: (payload: IElementPayHandler) => void;
    onPending: (payload: IElementPayHandler) => void;
}

export interface IPGHooks extends IPGTrace {
    onBeforePayment: (payload: IPayBeforePaymentHandler) => Promise<boolean>;
    onUnlockPayment: () => Promise<boolean>;
}

export interface IPGSelector {
    pgSelectedId?: string;
    pgSelectedElem?: PaymentElementEnum;
    onPgRegister?: ({ pgId, elem, name, icon }: IPGRegister) => void;
    onPgSelect?: (pgId: string, elem: string) => void;
    onPgUnregister?: ({ pgId, elem }: IPGDisable) => void;
    pgDisabledElem?: IPGDisable;
    isPgElemVisible?: (elem: PaymentElementEnum) => boolean;
}

export interface IPGTrace {
    onTraceEnd?: (transaction: Transaction) => void;
    onTraceStart?: (gatewayId: string) => ITransactionObject;
    onTraceClose?: (payload: IHandleSentryClose) => void;
}

export interface IPGExchange {
    currencyCode: string;
    isApplied: boolean;
    tip?: number;
    ratio: number;
    total: number;
    paymentMethod?: PaymentElementEnum;
    isRoutingApplied?: boolean;
    isInterrupted?: boolean;
}

export interface IPGExchangeProps {
    onExchangeChange?: (payload: Omit<IPGExchange, 'tip'>) => void;
    exchange?: IPGExchange;
}

export interface IPGSplitProps {
    hasSplitPayment?: boolean;
}

export interface IPGBaseProps {
    diningSessionID: string;
    sessionId: string;
    jwt?: string | null | undefined;
    url: IURLTopology;
    vendor: IRestaurant;
    amount: number;
    tip: number;
    currencyPrecision: number;
    gatewayId: string;
    disable: boolean;
    config: any;
    name: string;
    updateTimestamp?: number;
}

export interface IPGProps
    extends IPGBaseProps,
        IPGStateCallbacks,
        IPGHooks,
        IPGFallbackCallbacks,
        IPGSelector,
        IPGExchangeProps,
        IPGSplitProps {
    enableButton: boolean;
    onOverlayClick: () => void;
    onLoading?: (loading: boolean) => void;
}

export interface IPGPropsAll extends IPGProps {
    lang: string;
    remainingAmount: number;
}

export enum PaymentExchangeDecision {
    ExchangeUndecided = 'exchangeUndecided',
    UseForeignCurrency = 'useForeignCurrency',
    UseLocalCurrency = 'useLocalCurrency',
}

interface IExchangeData {
    paid_amount: string;
    currency: string;
}

export enum RecordStatusEnum {
    accepted = 'accepted',
    pending = 'pending',
    failed = 'failed',
}

export enum GatewayPaymentMethod {
    Unknown = 'unknown',
    Card = 'card',
    ApplePay = 'apple_pay',
    GooglePay = 'google_pay',
    StcPay = 'stc_pay',
    SavedCard = 'saved_card',
    Softpos = 'softpos',
    Pix = 'pix',
}

interface IKnetMedataData {
    knet_payment_id: string;
    knet_result: string;
    knet_transaction_id: string;
}

export interface IPaymentRecord {
    id: string;
    billAmount: string;
    tipAmount: string;
    total: string;
    createdAt: number;
    updatedAt: number;
    gatewayVendor: string;
    gatewayPaymentMethod?: GatewayPaymentMethod;
    status: RecordStatusEnum;
    accepted: boolean;
    reference: string;
    customerCommission: string;
    knetMetaData?: IKnetMedataData;
    exchangeData?: IExchangeData;
    transactionDateTime?: string;
}
